export const UNIFIED_NAVIGATION_UI_LOGGER_NAME = 'unified-navigation-ui';